var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.imageUrl
        ? _c("b-img", {
            staticClass: "configured-img",
            attrs: { src: _vm.imageUrl, alt: _vm.vehicleName }
          })
        : _c("body-style-icon", { attrs: { id: _vm.bodyStyleOrDefault } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }